import React from 'react'

export const UserIcon = React.memo((props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      {...props}
    >
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Blue-header-login"
          transform="translate(-1332.000000, -20.000000)"
        >
          <g id="blue-header-login">
            <g
              id="Avatars/Icon/xs-(24)"
              transform="translate(1332.000000, 20.000000)"
            >
              <g id="avatars/icon/xs-(24)">
                <circle
                  id="bg"
                  fill="#018065"
                  fillRule="nonzero"
                  cx="12"
                  cy="12"
                  r="12"
                />
                <g id="Icons/user" transform="translate(3.000000, 3.000000)">
                  <path
                    d="
                      M11.3200608,5.01157352
                      C10.4758946,6.23706415 9.34112072,7.06414974 7.8820849,7.28825657
                      C7.70143107,7.31600487 7.52708674,7.20947219 7.46935293,7.03605772
                      C7.38144524,6.7720103 7.13232695,6.58936634 6.84924218,6.58936634
                      C6.48859828,6.58936634 6.19620275,6.88195882 6.19620275,7.24290698
                      C6.19620686,7.24396448 6.19620686,7.24396448 6.19692647,7.25832564
                      C6.1980865,7.27930174 6.1980865,7.27930174 6.19870894,7.31358158
                      C6.19870894,7.86617258 6.4538786,8.28452343 6.8966454,8.60434281
                      C7.05808839,8.72095633 7.23306611,8.81524903 7.40795958,8.88810847
                      C7.51110997,8.93108023 7.58840749,8.95652988 7.62605374,8.96645832
                      C7.82631322,9.01927272 7.94584107,9.22442963 7.89302667,9.4246891
                      C7.84021227,9.62494858 7.63505536,9.74447643 7.43479589,9.69166203
                      C7.18071392,9.62465304 6.82068236,9.47466631 6.45748836,9.21232397
                      C5.83355774,8.76164631 5.44870894,8.13068643 5.44870894,7.31358158
                      C5.44870484,7.31252415 5.44870484,7.31252415 5.44798523,7.29816297
                      C5.4468252,7.27718682 5.4468252,7.27718682 5.44620275,7.24290698
                      C5.44620275,6.46785827 6.07427162,5.83936634 6.84924218,5.83936634
                      C7.34230028,5.83936634 7.7865528,6.09652723 8.03797594,6.4964348
                      C9.14337091,6.2512543 10.0213151,5.57488095 10.7024158,4.58611533
                      C11.0123339,4.13620194 11.2594525,3.65194103 11.4489294,3.1676856
                      C11.5619696,2.87878323 11.6299096,2.65694286 11.6590854,2.53662653
                      C11.7375948,2.21286623 12.1677773,2.14458318 12.342683,2.42811877
                      C12.8573201,3.26238471 12.9883115,3.83768876 12.982434,4.72654325
                      C12.9819359,4.78944451 12.9819359,4.78944451 12.9812838,4.85145988
                      C12.9800475,4.96916126 12.9796882,5.02211097 12.9798665,5.09744969
                      L12.9797515,5.10538048
                      C12.9768018,5.35789161 12.9976843,5.69569278 13.0626678,6.01711308
                      C13.0967816,6.18584622 13.1407,6.33256457 13.1935773,6.45002573
                      C13.2651706,6.60922665 13.369872,6.77752661 13.5433644,7.02324995
                      C13.5710903,7.06251904 13.6960075,7.23737444 13.7288303,7.28400657
                      C13.8011199,7.38671015 13.8554765,7.46757224 13.9029652,7.54465538
                      C14.0417711,7.76996367 14.1162666,7.95262219 14.1162666,8.14513568
                      C14.1162666,8.34615269 14.0244693,8.50924337 13.8689898,8.67225386
                      C13.7841073,8.76124781 13.7514712,8.78914629 13.5198471,8.97966155
                      C13.2857126,9.17224158 13.1969959,9.27667164 13.1969959,9.30149205
                      C13.1969959,10.4027496 12.9247237,11.7325616 12.2922028,12.013484
                      C11.7998968,12.2324417 11.0547553,12.3463773 10.125,12.37023
                      L10.125,15
                      C10.125,15.2800597 9.82915869,15.4612942 9.57965949,15.3340795
                      L5.45465949,13.2308238
                      C5.32906646,13.1667864 5.25,13.0377209 5.25,12.8967443
                      L5.25,11.3651243
                      C5.25,11.1580175 5.41789322,10.9901243 5.625,10.9901243
                      C5.83210678,10.9901243 6,11.1580175 6,11.3651243
                      L6,12.6670166
                      L9.375,14.3878622
                      L9.375,12
                      C9.375,11.7929687 9.54277543,11.6251068 9.74980671,11.625
                      C10.7577312,11.6244805 11.5507867,11.5224016 11.9875984,11.3281256
                      C12.2057496,11.2312378 12.4469959,10.0529601 12.4469959,9.30149205
                      C12.4469959,8.95211732 12.6193713,8.7492112 13.0434154,8.40042681
                      C13.2814877,8.20460781 13.3662666,8.11572247 13.3662666,8.14513568
                      C13.3662666,8.08649046 13.2998781,7.97872934 12.9306862,7.45582991
                      C12.7314035,7.17357883 12.6058698,6.97179244 12.5096199,6.75776314
                      C12.4314113,6.58403136 12.3719489,6.38538485 12.3275415,6.16573797
                      C12.2501108,5.78275116 12.2262891,5.39740487 12.2298027,5.09662006
                      C12.2299675,5.08470064 12.2299675,5.08470064 12.2299629,5.09062463
                      C12.2296747,5.02034456 12.2300509,4.96490316 12.2313251,4.84358295
                      C12.2319718,4.78204046 12.2319718,4.78204046 12.2324504,4.72158401
                      C12.2354034,4.27499781 12.2019069,3.93899269 12.0853997,3.59480524
                      C11.8851298,4.07796985 11.6321575,4.5584974 11.3200608,5.01157352
                    "
                    id="Stroke-41"
                    fill="#FFFFFF"
                    fillRule="nonzero"
                  />
                  <rect id="Padding" x="0" y="0" width="18" height="18" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
})

UserIcon.displayName = 'UserIcon'
